module.exports = __webpack_public_path__ + "fonts/Catamaran-Black.0e80350f.woff2";